import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import { noop } from 'lodash';
import "./index.css";

const WeLoveHumansPhoneInput = ({ country = "nl", value = "", onChange = noop, ...rest }) => (
    <PhoneInput
        country={country}
        value={value}
        onChange={onChange}
        {...rest}
    />
)

export default WeLoveHumansPhoneInput;